import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { FeatureFlagsService } from '@privanot/shared-ui/providers';
import { SIGN_IN_ROUTE } from '@client/auth/auth.routes';
import { authGuard } from '@client/auth/guards/auth.guards';

const splashRoute: Routes = [
    {
        path: 'splash',
        pathMatch: 'full',
        canMatch: [() => inject(FeatureFlagsService).isElectron()],
        loadComponent: () =>
            import('@client/shared/components/splash/connectivity-splash-screen/connectivity-splash-screen').then(
                (m) => m.ConnectivitySplashScreen,
            ),
    },
];

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'work-packages',
        pathMatch: 'full',
    },
    ...splashRoute,
    SIGN_IN_ROUTE,
    {
        // Authenticated routes (anything that has header + sidebar)
        path: '',
        canActivate: [authGuard],
        loadComponent: () =>
            import('@client/shared/components/layout/client-main-layout/client-main-layout').then((m) => m.ClientMainLayout),
        children: [
            {
                path: 'work-packages',
                data: { breadcrumb: 'features.workPackages.title' },
                loadChildren: () => import('@client/work-packages/work-packages.routes').then((m) => m.WORK_PACKAGES_ROUTES),
            },
            {
                path: 'inbox',
                data: { breadcrumb: 'features.inbox.title' },
                loadChildren: () => import('@client/inbox/inbox.routes').then((m) => m.INBOX_ROUTES),
            },
            {
                path: 'settings',
                data: { breadcrumb: 'features.settings.title' },
                loadChildren: () => import('@client/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'work-packages',
    },
];
